import { Link, Outlet, useParams } from "react-router";
import { findInternalDesk } from "./internalDesks.js";
import "./InternalWork.scss";

const InternalDesk = () => {
    const { deskId } = useParams();
    const desk = findInternalDesk(deskId);

    if (!desk) {
        return (
            <div className="container internal-work">
                <div className="internal-work__frame">
                    <p className="internal-work__eyebrow">Internal</p>
                    <h1>That desk is not on the list</h1>
                    <p><Link to="/internal/guide">Back to the guide</Link></p>
                </div>
            </div>
        );
    }

    return (
        <div className="container internal-work">
            <div className="internal-work__frame">
                <Outlet context={{ desk }} />
            </div>
        </div>
    );
};

export default InternalDesk;
